module.exports = __webpack_public_path__ + "static/media/rating.104060c6.svg";